export const convertColumnNameToPropertyName = (columnName: string) => {
	switch (columnName.toLowerCase()) {
		case "xyicon model":
			return "model";
		case "xyicon type":
		case "boundary type":
		case "markup type":
			return "typeName";
		case "xyicon x":
			return "iconX";
		case "xyicon y":
			return "iconY";
		case "xyicon z":
			return "iconZ";
		case "xyicon space id":
			return "spaceId";
		case "boundary geometry":
		case "markup geometry":
			return "geometryData";
		case "xyicon orientation":
		case "boundary orientation":
		case "markup orientation":
			return "orientation";
		case "xyicon port data":
			return "portData";
		case "parent xyicon id":
			return "parentXyiconRefId";
		case "xyicon id":
		case "boundary id":
			return "refId";
		case "markup color":
			return "color";
		case "markup text":
			return "text";
		case "markup fill transparency":
			return "fillTransparency";
		case "markup line thickness":
			return "lineThickness";
		case "markup settings":
		case "xyicon settings":
			return "settings";
		case "boundary misc":
		case "markup misc":
			return "misc";
	}
};

export const getClipboardData = async (): Promise<{htmlText: string; plainText: string}> => {
	const ret: {htmlText: string; plainText: string} = {
		htmlText: "",
		plainText: "",
	};

	try {
		const clipboardItems = await navigator.clipboard.read();

		for (const item of clipboardItems) {
			if (item.types.includes("text/html")) {
				const htmlBlob = await item.getType("text/html");
				const htmlText = await htmlBlob.text();

				ret.htmlText = htmlText;
			}

			if (item.types.includes("text/plain")) {
				const textBlob = await item.getType("text/plain");
				const plainText = await textBlob.text();

				ret.plainText = plainText;
			}
		}
	} catch (err) {
		console.error("Failed to read clipboard:", err);
	}

	return ret;
};
